import {
  IonButton,
  IonChip,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setFirstName,
  setFirstNamePNNV,
  setMiddleInitial,
  setLastName,
  setLastNamePNNV,
  setSuffix,
  setDOB,
  setDOBPNNV,
  setAge,
  setAgeUnit,
  setSSN,
  setSSNPNNV,
  setRace,
  setBloodType,
  setDLState,
  setDriversLicense,
  setGender,
  setGenderPNNV,
  setHeight,
  setHeightUnits,
  setWeight,
  setWeightPNNV,
  setWeightUnits,
  savePatientDemographics,
  setDnr,
  setBarriersToCare,
  setPatientID,
  setPatientRunID,
  setTexasWristband,
  setTriageColor,
  setBarriersToCarePNNV,
  setPreferredLanguage,
  setTriageColorPNNV,
  setSexPNNV,
  setSex,
  setAgePNNV,
  setRacePNNV,
} from '../store/patientDemographics.actions'
import { getPatientDemographicsSelector } from '../selectors'
import { isPlatformNative, transformDateWith4DigitYear, transformSSN } from '../../../utilities'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import MultiSelect from '../../../components/multiSelect/MultiSelect.component'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import NumberPad from '../../../components/numberPad/NumberPad.component'
import SInput from '../../../components/stringInput/StringInput.component'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import ScanDriversLicenseButton from '../../driversLicenseScanner/scanDriversLicenseButton/scanDriversLicenseButton.component'
import { numberPadKeysWithDecimal } from '../../../components/numberPad/NumberPad.types'
import { addCircleOutline, checkmarkSharp, closeCircleOutline } from 'ionicons/icons'
import Validation from '../../../components/validation/Validation.component'
import { getAllPNNVOptionsSelector, getPatientDemographicsOptionsSelector } from '../../options/selectors'
import { IOption, IPNNVOption } from '../../../common/common.types'
import { getPatientInformationState } from '../../patientInformation/selectors'
import {
  enableScroll,
  replacePatient,
  setSelectedOption,
} from '../../patientInformation/store/patientInformation.actions'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { IAlertState } from '../../../components/alert/store/alert.types'
import ReplacePatientButton from '../../patientInformation/replacePatient/ReplacePatientButton.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import './BasicPatientInformationSection.component.css'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import PhysicianInformation from '../physicianDetails/physicianDetails.component'
import { AccordianComponent } from '../../../components/accordian/Accordian.components'
import Employer from '../employer/content/Employer.content'
import { getEmployerSelector } from '../employer/selectors'
import Immunization from '../../patientImmunizations/content/Immunization.content'
import { IConfigurationsState } from '../../configurations/store/configurations.types'
import {
  getConfigurationsSelector,
  getDatapointsConfigSelector,
  getIsTexasServiceSelector,
} from '../../configurations/selectors'
import { IDataPointsConfig } from '../../configurations/store/configurations.types'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { getTripInformationSelector } from '../../tripInformation/selectors'

const BasicPatientInformation: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const patientDemographics = useSelector(getPatientDemographicsSelector)
  const {
    servicePtID,
    patientRunID,
    texasWristband,
    firstName,
    firstNamePNNV,
    middleInitial,
    lastName,
    lastNamePNNV,
    suffix,
    triageColor,
    triageColorPNNV,
    dOB,
    dOBPNNV,
    age,
    agePNNV,
    ageUnit,
    sSN,
    sSNPNNV,
    weight,
    weightPNNV,
    weightUnits,
    height,
    heightUnits,
    sex,
    sexPNNV,
    gender,
    genderPNNV,
    race,
    racePNNV,
    bloodType,
    driversLicense,
    dlState,
    dnr,
    barriersToCare,
    barriersToCarePNNV,
    preferredLanguage,
  } = patientDemographics

  const allPNNVOptions = useSelector(getAllPNNVOptionsSelector)
  const weightOptions = allPNNVOptions?.['eExam.01']
  const lastNameOptions = allPNNVOptions?.['ePatient.02']
  const firstNameOptions = allPNNVOptions?.['ePatient.03']
  const sSNOptions = allPNNVOptions?.['ePatient.12']
  const dOBOptions = allPNNVOptions?.['ePatient.17']
  const sexPnnvOptions = allPNNVOptions?.['ePatient.25']
  const agePNNVOptions = allPNNVOptions?.['ePatient.15']
  const racePNNVOptions = allPNNVOptions?.['ePatient.14']
  const patientDemographicsOptions = useSelector(getPatientDemographicsOptionsSelector)
  const {
    weightUnitOptions,
    heightUnitOptions,
    sexOptions,
    genderOptions,
    raceOptions,
    bloodTypeOptions,
    dLStateOptions,
    suffixOptions,
    triageColorOptions,
    ageUnitOptions,
  } = patientDemographicsOptions

  const [flag, setFlag] = useState(true)
  const { isTablet } = useDeviceMetrics()
  const patientInformationState = useSelector(getPatientInformationState)
  const { searchImport, __enablePageScroll } = patientInformationState
  const employer = useSelector(getEmployerSelector)
  const {
    industry,
    occupation,
    primaryBusiness,
    address1,
    address2,
    city,
    state,
    county,
    zipCode,
    country,
    phoneNumber,
    phoneType,
  } = employer
  const isEmployerDataAvailable = Boolean(
    industry ||
      occupation ||
      primaryBusiness ||
      address1 ||
      address2 ||
      city ||
      state ||
      county ||
      zipCode ||
      country ||
      phoneNumber ||
      phoneType
  )
  const configurationsState: IConfigurationsState = useSelector(getConfigurationsSelector)
  const { serviceConfig } = configurationsState
  const { PR_PTRUN_ID, PR_PTRUN_ID_LABEL, PR_PT_ID, PR_PT_ID_LABEL } = serviceConfig
  const allowedPatientServiceConfigValues = [1, 2]

  const dataPointsConfig: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_MASSCAS, DP_TRIAGE } = dataPointsConfig
  const isTexasService = useSelector(getIsTexasServiceSelector)

  const tripInformationData: ITripInformationState = useSelector(getTripInformationSelector)
  const { massCasualty } = tripInformationData

  const [IBW, setIBW] = useState<number | null>(null)

  const showTriageColor = DP_TRIAGE === 1 && (DP_MASSCAS === 0 || (DP_MASSCAS === 1 && massCasualty?.id === 1))

  useEffect(() => {
    if (__enablePageScroll) {
      let content = document.getElementById('DNR')
      setTimeout(() => {
        content?.scrollIntoView({
          behavior: 'smooth',
        })
        content = null
      }, 100)
    }
  }, [__enablePageScroll])

  const setPatientIDOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setPatientID(e.detail.value))
    save()
  }
  const setPatientRunIDOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setPatientRunID(e.detail.value))
    save()
  }
  const setTexasWristbandOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setTexasWristband(e.detail.value))
    save()
  }
  const setFirstNameOnChange = (e: CustomEvent) => {
    if (e && 'preventDefault' in e) e.preventDefault()
    if (!searchImport) {
      dispatch(setFirstName(e.detail.value))
      save()
    }
  }

  const setFirstNamePNNVValues = (option: IPNNVOption | null) => {
    dispatch(setFirstNamePNNV(option))
    dispatch(setFirstName(''))
    save()
  }

  const setFirstNamePNNVOnChange = (option: IPNNVOption | null) => {
    if (searchImport) {
      const alert: IAlertState = {
        header: t('patientDemographics.NameChangeAlertTitle'),
        message: t('patientDemographics.NameChangeAlertMessage'),
        buttons: [
          { text: t('patientSearch.updatePatient'), handler: () => setFirstNamePNNVValues(option) },
          { text: t('patientSearch.newPatientButton'), role: 'destructive', handler: handleYesReplacePatient },
          { text: t('common.buttons.Cancel') },
        ],
      }
      dispatch(showAlert(alert))
      return
    }
    setFirstNamePNNVValues(option)
  }

  const setMiddleInitialOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (!searchImport) {
      dispatch(setMiddleInitial(e.detail.value))
      save()
    }
  }

  const setLastNameOnChange = (e: CustomEvent) => {
    if (e && 'preventDefault' in e) e.preventDefault()
    if (!searchImport) {
      dispatch(setLastName(e.detail.value))
      save()
    }
  }

  const setLastNamePNNVValues = (option: IPNNVOption | null) => {
    dispatch(setLastNamePNNV(option))
    dispatch(setLastName(''))
    save()
  }

  const setLastNamePNNVOnChange = (option: IPNNVOption | null) => {
    if (searchImport) {
      const alert: IAlertState = {
        header: t('patientDemographics.NameChangeAlertTitle'),
        message: t('patientDemographics.NameChangeAlertMessage'),
        buttons: [
          { text: t('patientSearch.updatePatient'), handler: () => setLastNamePNNVValues(option) },
          { text: t('patientSearch.newPatientButton'), role: 'destructive', handler: handleYesReplacePatient },
          { text: t('common.buttons.Cancel') },
        ],
      }
      dispatch(showAlert(alert))
      return
    }
    setLastNamePNNVValues(option)
  }

  const setSuffixOnChange = (option: IOption) => {
    dispatch(setSuffix(option))
    save()
  }

  const setTriageColorOnChange = (option: IOption) => {
    dispatch(setTriageColor(option))
    save()
  }

  const setTriageColorPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setTriageColorPNNV(option))
    save()
  }

  const setDobOnChange = (numbers: string[]) => {
    let newDate = null
    if (numbers.length) {
      newDate = transformDateWith4DigitYear(numbers.join(''))
    }
    dispatch(setDOB(newDate))
    save()
  }

  const setDOBPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setDOBPNNV(option))
    dispatch(setDOB(''))
    save()
  }

  const isApproximateSelected = (pnnValue: IPNNVOption | null) => {
    return pnnValue?.id === 8801029
  }

  const setAgeOnChange = (numbers: string[]) => {
    dispatch(setAge(numbers.length ? numbers.join('') : null))
    save()
  }

  const setAgePNNVOnChange = (option: IPNNVOption | null) => {
    if (!age && isApproximateSelected(option)) {
      const alertState: IAlertState = {
        header: '',
        message: t('patientDemographics.AgeRequiredForApproximateWarning'),
        buttons: [{ text: t('pnnv.ok') }],
      }
      dispatch(showAlert(alertState))
    } else {
      dispatch(setAgePNNV(option))
    }
    if (!isApproximateSelected(option) && option) {
      dispatch(setAge(''))
    }
    save()
  }

  const setAgeUnitOnChange = (option: IOption) => {
    dispatch(setAgeUnit(option))
    save()
  }

  const setSSNOnChange = (numbers: string[]) => {
    let newSSN = null
    if (numbers.length) {
      newSSN = transformSSN(numbers.join(''))
    }
    dispatch(setSSN(newSSN))
    save()
  }

  const setSSNPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setSSNPNNV(option))
    dispatch(setSSN(''))
    save()
  }

  const setWeightOnChange = (numbers: string[]) => {
    dispatch(setWeight(numbers.length ? numbers.join('') : null))
    save()
  }

  const setWeightPNNVOnChange = (pnnvOption: IPNNVOption | null) => {
    dispatch(setWeightPNNV(pnnvOption))
    dispatch(setWeight(''))
    dispatch(setWeightUnits(null))
    save()
  }

  const setWeightUnitOnChange = (option: IOption) => {
    dispatch(setWeightUnits(option))
    save()
  }

  const calculateIBW = () => {
    if (!height || !sex || !heightUnits) {
      setIBW(null)
      return
    }

    const heightValue = parseFloat(height)
    if (isNaN(heightValue)) {
      setIBW(null)
      return
    }

    const heightInInches = heightUnits.id && String(heightUnits.id) === 'cm' ? heightValue / 2.54 : heightValue

    let ibw = null

    if (sex.id && String(sex.id) === 'M' && heightInInches >= 60) {
      ibw = Math.round((50 + 2.3 * (heightInInches - 60)) * 100) / 100
    } else if (sex.id && String(sex.id) === 'F' && heightInInches >= 60) {
      ibw = Math.round((45.5 + 2.3 * (heightInInches - 60)) * 100) / 100
    }

    setIBW(ibw)
  }

  const setHeightOnChange = (numbers: string[]) => {
    dispatch(setHeight(numbers.length ? numbers.join('') : null))
    save()
  }

  const setHeightUnitOnChange = (option: IOption) => {
    dispatch(setHeightUnits(option))
    save()
  }

  const setSexOnChange = (option: IOption) => {
    dispatch(setSex(option))
    dispatch(setGender(option))
    save()
  }

  const setSexPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setSexPNNV(option))
    save()
  }

  const setGenderOnChange = (option: IOption) => {
    dispatch(setGender(option))
    save()
  }

  const setGenderPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setGenderPNNV(option))
    save()
  }

  const setBloodTypeOnChange = (option: IOption) => {
    dispatch(setBloodType(option))
    save()
  }

  const setDriversLicenseOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setDriversLicense(e.detail.value))
    save()
  }

  const setDLStateOnChange = (option: IOption) => {
    dispatch(setDLState(option))
    save()
  }

  const save = () => {
    dispatch(savePatientDemographics())
  }

  const showDoNotResuscitateOptions = () => {
    if (isTablet) {
      dispatch(setSelectedOption(PatientInformationConstants.SET_DO_NOT_RESUSCITATE))
    } else {
      history.push(TabConstants.DO_NOT_RESUSCITATE)
    }
  }

  const showBarriersToCareOptions = () => {
    if (isTablet) {
      dispatch(setSelectedOption(PatientInformationConstants.SET_BARRIERS_TO_CARE))
    } else {
      history.push(TabConstants.BARRIERS_TO_CARE)
    }
  }

  const showPreferredLanguageOptions = () => {
    if (isTablet) {
      dispatch(setSelectedOption(PatientInformationConstants.SET_PREFERRED_LANGUAGE))
    } else {
      history.push(TabConstants.PREFERRED_LANGUAGE)
    }
  }

  const handleCancelPatientNameChange = (e: React.FocusEvent<HTMLIonInputElement>, label: string) => {
    if (label === 'firstName') {
      e.target.value = firstName
      dispatch(setFirstName(firstName))
    } else if (label === 'lastName') {
      e.target.value = lastName
      dispatch(setLastName(lastName))
    } else if (label === 'middleInitial') {
      e.target.value = middleInitial
      dispatch(setMiddleInitial(middleInitial))
    }
    save()
  }

  const handleUpdatePatientNameChange = (e: React.FocusEvent<HTMLIonInputElement>, label: string) => {
    if (label === 'firstName') {
      dispatch(setFirstName(e.target.value))
    } else if (label === 'lastName') {
      dispatch(setLastName(e.target.value))
    } else if (label === 'middleInitial') {
      dispatch(setMiddleInitial(e.target.value))
    }
    save()
  }

  const showNameChangeAlert = (e: React.FocusEvent<HTMLIonInputElement>, label: string) => {
    let showNameChangeAlert = false
    const fname = firstNamePNNV?.name || firstName
    const lname = lastNamePNNV?.name || lastName

    if (label === 'firstName' && e.target.value !== fname) {
      showNameChangeAlert = true
    } else if (label === 'lastName' && e.target.value !== lname) {
      showNameChangeAlert = true
    } else if (label === 'middleInitial' && e.target.value !== (middleInitial ?? '')) {
      showNameChangeAlert = true
    }
    if (searchImport && showNameChangeAlert) {
      const alert: IAlertState = {
        header: t('patientDemographics.NameChangeAlertTitle'),
        message: t('patientDemographics.NameChangeAlertMessage'),
        buttons: [
          { text: t('patientSearch.updatePatient'), handler: () => handleUpdatePatientNameChange(e, label) },
          { text: t('patientSearch.newPatientButton'), role: 'destructive', handler: handleYesReplacePatient },
          { text: t('common.buttons.Cancel'), handler: () => handleCancelPatientNameChange(e, label) },
        ],
      }
      dispatch(showAlert(alert))
    }
  }

  const onReplaceButtonClick = () => {
    const alert: IAlertState = {
      header: t('patientDemographics.ReplacePatient'),
      message: t('patientDemographics.ReplacePatientAlertMessage'),
      buttons: [
        { text: t('common.buttons.Cancel') },
        { text: t('common.buttons.Yes'), role: 'destructive', handler: handleYesReplacePatient },
      ],
    }
    dispatch(showAlert(alert))
  }

  useEffect(() => {
    if (flag) {
      firstName && dispatch(setFirstName(firstName))
      middleInitial && dispatch(setMiddleInitial(middleInitial))
      lastName && dispatch(setLastName(lastName))
      dOB && dispatch(setDOB(dOB))
      age && dispatch(setAge(age))
      sSN && dispatch(setSSN(sSN))
      weight && dispatch(setWeight(weight))
      height && dispatch(setHeight(height))
      driversLicense && dispatch(setDriversLicense(driversLicense))
      dispatch(enableScroll(false))
    }
  }, [flag])

  useEffect(() => {
    setFlag(true)

    return () => {
      setFlag(false)
    }
  }, [])

  useEffect(() => {
    calculateIBW()
  }, [height, sex, heightUnits])

  const handleYesReplacePatient = () => {
    dispatch(replacePatient())
    if (!isTablet) history.push(TabConstants.PATIENT_INFO_ROUTE)
  }

  const removeFilterChip = (option: IOption) => {
    const updatedDnr = [...dnr]
    const index = updatedDnr.findIndex((opt) => opt.id === option.id)
    if (index !== -1) {
      updatedDnr.splice(index, 1)
    }
    dispatch(setDnr(updatedDnr))
    save()
  }

  const removeBarriersToCareChip = (option: IOption) => {
    const updatedBarriersToCare = [...barriersToCare]
    const index = updatedBarriersToCare.findIndex((opt) => opt.id === option.id)
    if (index !== -1) {
      updatedBarriersToCare.splice(index, 1)
    }
    dispatch(setBarriersToCare(updatedBarriersToCare))
    dispatch(setBarriersToCarePNNV(null))
    save()
  }

  const handlePreferredLanguageChipDeletion = (option: IOption) => {
    const updatedValues = preferredLanguage.filter((o) => String(o.id) !== String(option.id))
    dispatch(setPreferredLanguage(updatedValues))
    save()
  }

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('patientDemographics.details.PatientDetails')}
        </IonLabel>
      </IonItemDivider>

      {!searchImport && isPlatformNative() && <ScanDriversLicenseButton />}
      {searchImport && <ReplacePatientButton onClickAction={onReplaceButtonClick}></ReplacePatientButton>}

      <IonItemDivider color='light' />

      <IonList className={isTablet ? 'ion-margin-horizontal' : ''}>
        <IonGrid className='no-padding'>
          <IonRow>
            {(allowedPatientServiceConfigValues.includes(PR_PT_ID) || servicePtID) && (
              <IonCol className='picklist'>
                <SInput
                  isPHI
                  label={PR_PT_ID_LABEL ?? t('patientDemographics.basicInfo.servicePtID')}
                  dataTestID='PatientID'
                  inputValue={servicePtID}
                  onChangeAction={setPatientIDOnChange}
                />
                <Validation id={PatientDemographicsConstants.SET_PATIENT_ID} />
              </IonCol>
            )}
            {(allowedPatientServiceConfigValues.includes(PR_PTRUN_ID) || patientRunID) && (
              <IonCol className='picklist'>
                <SInput
                  isPHI
                  label={PR_PTRUN_ID_LABEL ?? t('patientDemographics.basicInfo.patientRunID')}
                  dataTestID='PatientRunID'
                  inputValue={patientRunID}
                  onChangeAction={setPatientRunIDOnChange}
                />
                <Validation id={PatientDemographicsConstants.SET_PATIENT_RUN_ID} />
              </IonCol>
            )}
          </IonRow>

          <hr className='field-divider' />
          {isTexasService && (
            <>
              <IonRow>
                <IonCol className='picklist'>
                  <SInput
                    isPHI
                    label={t('patientDemographics.basicInfo.texasWristband')}
                    dataTestID='TexasWristband'
                    inputValue={texasWristband}
                    onChangeAction={setTexasWristbandOnChange}
                  />
                  <Validation id={PatientDemographicsConstants.SET_TEXAS_WRISTBAND} />
                </IonCol>
              </IonRow>
              <hr className='field-divider' />
            </>
          )}
          {showTriageColor && (
            <>
              <IonRow>
                <IonCol className='picklist'>
                  <SingleSelect
                    dataTestID='TriageColor'
                    selectedOption={triageColor}
                    listHeader={t('patientDemographics.basicInfo.TriageColor')}
                    options={triageColorOptions}
                    action={setTriageColorOnChange}
                    label={t('patientDemographics.basicInfo.TriageColor')}
                    pnnvAction={setTriageColorPNNVOnChange}
                    selectedPNNVOption={triageColorPNNV}
                  />
                </IonCol>
              </IonRow>
              <hr className='field-divider' />
            </>
          )}
          <IonRow>
            <IonCol className='picklist'>
              <SInput
                isPHI
                label={t('patientDemographics.basicInfo.FirstName')}
                dataTestID='FirstName'
                inputValue={firstName}
                onChangeAction={setFirstNameOnChange}
                onBlurAction={(e) => showNameChangeAlert(e, 'firstName')}
                pnnvOptions={firstNameOptions}
                pnnvValue={firstNamePNNV}
                pnnvAction={setFirstNamePNNVOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_FIRST_NAME} />
            </IonCol>
            <IonCol className='picklist'>
              <SInput
                isPHI
                label={t('patientDemographics.basicInfo.MiddleInitial')}
                dataTestID='MiddleInitial'
                inputValue={middleInitial}
                onChangeAction={setMiddleInitialOnChange}
                onBlurAction={(e) => showNameChangeAlert(e, 'middleInitial')}
              />
              <Validation id={PatientDemographicsConstants.SET_MIDDLE_INITIAL} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <SInput
                isPHI
                label={t('patientDemographics.basicInfo.LastName')}
                dataTestID='LastName'
                inputValue={lastName}
                onChangeAction={setLastNameOnChange}
                onBlurAction={(e) => showNameChangeAlert(e, 'lastName')}
                pnnvOptions={lastNameOptions}
                pnnvValue={lastNamePNNV}
                pnnvAction={setLastNamePNNVOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_LAST_NAME} />
            </IonCol>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='Suffix'
                selectedOption={suffix}
                listHeader={t('patientDemographics.basicInfo.Suffix')}
                options={suffixOptions}
                action={setSuffixOnChange}
                label={t('patientDemographics.basicInfo.Suffix')}
              />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='DOB'
                dataTestId='DOB'
                values={dOB ? dOB.toString().split('') : []}
                label={t('patientDemographics.basicInfo.DOB')}
                onNumPadClick={setDobOnChange}
                action={PatientDemographicsConstants.SET_DOB}
                pnnvOptions={dOBOptions}
                pnnvValue={dOBPNNV}
                pnnvAction={setDOBPNNVOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_DOB} />
            </IonCol>
            <IonCol className='ion-hide-md-down picklist'>
              <NumberPad
                isPHI
                elementId='AgeTablet'
                dataTestId='AgeTablet'
                values={age ? age.toString().split('') : []}
                label={t('patientDemographics.basicInfo.Age')}
                onNumPadClick={setAgeOnChange}
                action={PatientDemographicsConstants.SET_AGE}
                pnnvAction={setAgePNNVOnChange}
                pnnvOptions={agePNNVOptions}
                pnnvValue={agePNNV}
                useBothNormalAndPertinent={isApproximateSelected(agePNNV)}
                overridePicklistWithNumberPad={!isApproximateSelected(agePNNV)}
              />
              <Validation id={PatientDemographicsConstants.SET_AGE} isTablet={true} />
            </IonCol>
            <IonCol className='ion-hide-md-down picklist'>
              <SingleSelect
                dataTestID='AgeUnitTablet'
                selectedOption={ageUnit}
                listHeader={t('patientDemographics.basicInfo.AgeUnit')}
                label={t('patientDemographics.basicInfo.AgeUnit')}
                options={ageUnitOptions}
                action={setAgeUnitOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_AGE_UNIT} />
            </IonCol>
          </IonRow>

          <hr className='field-divider ion-hide-md-up' />

          <IonRow className='ion-hide-md-up'>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='AgeMobile'
                dataTestId='AgeMobile'
                values={age ? age.toString().split('') : []}
                label={t('patientDemographics.basicInfo.Age')}
                onNumPadClick={setAgeOnChange}
                action={PatientDemographicsConstants.SET_AGE}
                pnnvAction={setAgePNNVOnChange}
                pnnvOptions={agePNNVOptions}
                pnnvValue={agePNNV}
                useBothNormalAndPertinent={isApproximateSelected(agePNNV)}
                overridePicklistWithNumberPad={!isApproximateSelected(agePNNV)}
              />
              <Validation id={PatientDemographicsConstants.SET_AGE} isMobile={true} />
            </IonCol>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='AgeUnitMobile'
                selectedOption={ageUnit}
                listHeader={t('patientDemographics.basicInfo.AgeUnit')}
                label={t('patientDemographics.basicInfo.AgeUnit')}
                options={ageUnitOptions}
                action={setAgeUnitOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_AGE_UNIT} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='SSN'
                dataTestId='SSN'
                values={sSN ? sSN.toString().split('') : []}
                label={t('patientDemographics.basicInfo.SSN')}
                onNumPadClick={setSSNOnChange}
                action={PatientDemographicsConstants.SET_SSN}
                pnnvOptions={sSNOptions}
                pnnvValue={sSNPNNV}
                pnnvAction={setSSNPNNVOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_SSN} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />
        </IonGrid>
      </IonList>

      <IonItemDivider color='light' />

      <IonList className={isTablet ? 'ion-margin-horizontal' : ''}>
        <IonGrid className='no-padding'>
          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='Weight'
                dataTestId='Weight'
                values={weight ? weight.toString().split('') : []}
                validCharacters={numberPadKeysWithDecimal}
                label={t('patientDemographics.details.Weight')}
                onNumPadClick={setWeightOnChange}
                action={PatientDemographicsConstants.SET_WEIGHT}
                pnnvOptions={weightOptions}
                pnnvAction={setWeightPNNVOnChange}
                pnnvValue={weightPNNV}
              />
              <Validation id={PatientDemographicsConstants.SET_WEIGHT} />
            </IonCol>
            {!weightPNNV && (
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='WeightUnit'
                  selectedOption={weightUnits}
                  listHeader={t('patientDemographics.details.WeightUnit')}
                  label={t('patientDemographics.details.WeightUnit')}
                  options={weightUnitOptions}
                  action={setWeightUnitOnChange}
                />
              </IonCol>
            )}
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='Height'
                dataTestId='Height'
                values={height ? height.toString().split('') : []}
                label={t('patientDemographics.details.Height')}
                onNumPadClick={setHeightOnChange}
                action={PatientDemographicsConstants.SET_HEIGHT}
                validCharacters={numberPadKeysWithDecimal}
              />
              <Validation id={PatientDemographicsConstants.SET_HEIGHT} />
            </IonCol>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='HeightUnit'
                selectedOption={heightUnits}
                listHeader={t('patientDemographics.details.HeightUnit')}
                label={t('patientDemographics.details.HeightUnit')}
                options={heightUnitOptions}
                action={setHeightUnitOnChange}
              />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <SingleSelect
                isPHI
                dataTestID='Sex'
                selectedOption={sex}
                listHeader={t('patientDemographics.details.Sex')}
                label={t('patientDemographics.details.Sex')}
                options={[...sexOptions, ...sexPnnvOptions]}
                action={setSexOnChange}
                pnnvAction={setSexPNNVOnChange}
                selectedPNNVOption={sexPNNV}
              />
            </IonCol>
            <IonCol className='picklist'>
              <SingleSelect
                isPHI
                dataTestID='Gender'
                selectedOption={gender}
                listHeader={t('patientDemographics.details.Gender')}
                label={t('patientDemographics.details.Gender')}
                options={genderOptions}
                action={setGenderOnChange}
                pnnvAction={setGenderPNNVOnChange}
                selectedPNNVOption={genderPNNV}
              />
              <Validation id={PatientDemographicsConstants.SET_GENDER} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <NumberPad
                isPHI
                elementId='IBW'
                dataTestId='IBW'
                values={IBW ? IBW.toString().split('') : []}
                label={t('patientDemographics.details.IBW')}
                onNumPadClick={() => {
                  return
                }}
                disabled={true}
              />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <SingleSelect
                isPHI
                dataTestID='BloodType'
                selectedOption={bloodType}
                listHeader={t('patientDemographics.details.BloodType')}
                label={t('patientDemographics.details.BloodType')}
                options={bloodTypeOptions}
                action={setBloodTypeOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_BLOOD_TYPE} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <MultiSelect
                dataTestID='Race'
                listHeader={t('patientDemographics.details.RaceHeader')}
                options={[...raceOptions, ...racePNNVOptions]}
                savedValues={race}
                action={setRace}
                callback={savePatientDemographics}
                label={t('patientDemographics.details.Race')}
                pnnvAction={setRacePNNV}
                savedPNNVValue={racePNNV}
              />
              <Validation id={PatientDemographicsConstants.SET_RACE} />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />

          <IonRow>
            <IonCol className='picklist'>
              <SInput
                isPHI
                label={t('patientDemographics.details.DriversLicenseNumber')}
                dataTestID='DriversLicenseNumber'
                inputValue={driversLicense}
                onChangeAction={setDriversLicenseOnChange}
              />
              <Validation id={PatientDemographicsConstants.SET_DRIVERS_LICENSE_NUMBER} />
            </IonCol>
            <IonCol className='picklist'>
              <SingleSelect
                dataTestID='DriverLicenseState'
                selectedOption={dlState}
                listHeader={t('patientDemographics.details.DriversLicenseState')}
                label={t('patientDemographics.details.DriversLicenseState')}
                options={dLStateOptions}
                action={setDLStateOnChange}
              />
            </IonCol>
          </IonRow>

          <hr className='field-divider' />
          <IonRow id='DNR'>
            <IonButton
              data-testid='AddDNR'
              className='transform-none'
              fill='clear'
              color='primary-alt'
              onClick={showDoNotResuscitateOptions}>
              <IonIcon icon={addCircleOutline} />
              <IonLabel>{t('patientDemographics.details.DoNotResuscitate')}</IonLabel>
            </IonButton>
            {dnr.length > 2 && <IonIcon color='success' className='checkmark-icon' icon={checkmarkSharp} />}
          </IonRow>
          {dnr.length > 0 && dnr.length < 3 && (
            <IonItem lines='none'>
              <IonRow className='ion-nowrap no-flex-shrink' id='List-Row'>
                {dnr.map((option: IOption) => (
                  <IonChip
                    data-testid={`Chip${option.id}`}
                    key={`Chip_${option.id}${option.name}`}
                    className='lookup-search-chips custom-background'>
                    <IonLabel>{option.name}</IonLabel>
                    <IonIcon color='white' icon={closeCircleOutline} onClick={() => removeFilterChip(option)} />
                  </IonChip>
                ))}
              </IonRow>
            </IonItem>
          )}
          <IonRow id='BarriersToCare'>
            <IonButton
              data-testid='AddBarriersToCare'
              className='transform-none'
              fill='clear'
              color='primary-alt'
              onClick={showBarriersToCareOptions}>
              <IonIcon icon={addCircleOutline} />
              <IonLabel>{t('patientDemographics.details.BarriersToCare')}</IonLabel>
            </IonButton>
            {barriersToCare.length > 2 && <IonIcon color='success' className='checkmark-icon' icon={checkmarkSharp} />}
          </IonRow>
          {barriersToCare.length > 0 && barriersToCare.length < 3 && (
            <IonItem lines='none'>
              <IonRow className='ion-nowrap no-flex-shrink' id='List-Row'>
                {barriersToCare.map((option: IOption) => (
                  <IonChip
                    data-testid={`Chip${option.id}`}
                    key={`Chip_${option.id}${option.name}`}
                    className='lookup-search-chips custom-background'>
                    <IonLabel>{option.name}</IonLabel>
                    <IonIcon color='white' icon={closeCircleOutline} onClick={() => removeBarriersToCareChip(option)} />
                  </IonChip>
                ))}
              </IonRow>
            </IonItem>
          )}
          {barriersToCarePNNV && (
            <IonItem lines='none'>
              <IonRow className='ion-nowrap no-flex-shrink' id='List-Row'>
                <IonChip
                  data-testid={`Chip${barriersToCarePNNV?.id}`}
                  key={`Chip_${barriersToCarePNNV?.id}${barriersToCarePNNV?.name}`}
                  className='lookup-search-chips custom-background'>
                  <IonLabel>{barriersToCarePNNV?.name}</IonLabel>
                  <IonIcon
                    color='white'
                    icon={closeCircleOutline}
                    onClick={() => removeBarriersToCareChip(barriersToCarePNNV)}
                  />
                </IonChip>
              </IonRow>
            </IonItem>
          )}
          <>
            <IonRow id='PreferredLanguageField'>
              <IonButton
                data-testid='AddPreferredLanguage'
                className='transform-none'
                fill='clear'
                color='primary-alt'
                onClick={showPreferredLanguageOptions}>
                <IonIcon icon={addCircleOutline} />
                <IonLabel>{t('patientDemographics.details.PreferredLanguage')}</IonLabel>
              </IonButton>
              {preferredLanguage.length > 2 && (
                <IonIcon color='success' className='checkmark-icon' icon={checkmarkSharp} />
              )}
            </IonRow>
            {preferredLanguage.length > 0 && preferredLanguage.length < 3 && (
              <IonItem
                lines='none'
                style={{
                  '--background-hover': 'transparent',
                }}>
                <IonRow className='ion-nowrap no-flex-shrink' id='List-Row'>
                  {preferredLanguage.map((option: IOption) => (
                    <IonChip
                      data-testid={`Chip${option.id}`}
                      key={`Chip_${option.id}${option.name}`}
                      className='lookup-search-chips custom-background'>
                      <IonLabel>{option.name}</IonLabel>
                      <IonIcon
                        color='white'
                        icon={closeCircleOutline}
                        onClick={() => handlePreferredLanguageChipDeletion(option)}
                      />
                    </IonChip>
                  ))}
                </IonRow>
              </IonItem>
            )}
          </>
          <IonItemDivider color='light' />
          <Immunization />
          <PhysicianInformation />

          <IonRow>
            <IonCol className='ion-no-padding'>
              <AccordianComponent
                dataTestId={'Employer'}
                heading={t('patientDemographics.employer.Employer')}
                content={<Employer />}
                isCheckMark={isEmployerDataAvailable}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonList>
    </>
  )
}

export default BasicPatientInformation
